import { sample } from 'effector';
import { signout } from '@features/common';
import { GeneralJsonTypeBase } from '@unicorn/sdui';
import { checkOpenedIdAndPreloadData } from './heplers/check-request-scheme-data';
import { getPayloadFileds } from './heplers/get-payload-fileds';
import { prepareDataToRequest } from './heplers/prepare-data-to-request';
import {
  $customFieldsSduiJson,
  $errorSduiRequests,
  $sduiReadonly,
  $sduiTicketData,
  clearError,
  createSduiTicket,
  CustomFieldsGate,
  errorOccured,
  fxCreateSduiTicket,
  fxGetCustomFieldsSduiJson,
  fxUpdateSduiTicket,
  getCustomFieldsSduiJson,
  NEW_OPENED_ID,
  setSduiReadonly,
  updateSduiTicket,
} from './model';

$sduiReadonly
  .on(setSduiReadonly, (_, status) => status)
  .reset([
    fxUpdateSduiTicket.done,
    fxCreateSduiTicket.done,
    CustomFieldsGate.close,
    signout,
  ]);

const setSduiToReadonly = sample({
  clock: setSduiReadonly,
  filter: (status) => status,
});

sample({
  clock: CustomFieldsGate.state,
  fn: ({ openedId }) => openedId !== NEW_OPENED_ID,
  target: $sduiReadonly,
});

/** Формирую запрос для получения JSON */
sample({
  clock: [CustomFieldsGate.state, getCustomFieldsSduiJson],
  filter: (data) => checkOpenedIdAndPreloadData(data),
  fn: (data) => prepareDataToRequest(data),
  target: fxGetCustomFieldsSduiJson,
});

/** Возвращаю данные заявки при переходе в просмотр и при обновлении заявки */
sample({
  clock: [setSduiToReadonly, fxUpdateSduiTicket.doneData],
  source: { sduiTicketData: $sduiTicketData },
  fn: ({ sduiTicketData }) => ({ openedId: sduiTicketData.id }),
  target: getCustomFieldsSduiJson,
});

$customFieldsSduiJson
  .on(fxGetCustomFieldsSduiJson.done, (_, { result }) =>
    Array.isArray(result.schema)
      ? (result.schema as GeneralJsonTypeBase[])[0]
      : result.schema
  )
  .reset([CustomFieldsGate.close, signout]);

$sduiTicketData
  .on(fxGetCustomFieldsSduiJson.done, (_, { result }) => result.ticket)
  .reset([CustomFieldsGate.close, signout]);

$errorSduiRequests
  .on(errorOccured, (_, { error }) => JSON.parse(error.message ?? '{}'))
  .reset([signout, clearError]);

/** Создание заявки */
sample({
  clock: createSduiTicket,
  fn: (sduiData) => ({ fields: getPayloadFileds(sduiData) }),
  target: fxCreateSduiTicket,
});

/** Редактирование заявки */
sample({
  clock: updateSduiTicket,
  fn: ({ openedId, sduiData }) => ({
    id: openedId,
    fields: getPayloadFileds(sduiData),
  }),
  target: fxUpdateSduiTicket,
});
